import initCarousel from '../../components/carousel';
import initTab from '@components/tab';

const loadCarousel = () => {
	const carousels = document.querySelectorAll( '.wp-block-rte-carousel' );

	if ( ! carousels ) {
		return;
	}

	carousels.forEach( ( block ) => {
		const carouselContainer = block.querySelectorAll( '.rte-carousel' );
		carouselContainer.forEach( ( carousel ) => {
			initCarousel( carousel );
		} );

		const tabList = block.querySelector( '.rte-carousel-groups' );
		if ( tabList ) {
			initTab( tabList );
		}
	} );
};

window.addEventListener( 'DOMContentLoaded', loadCarousel );
window.addEventListener( 'altisBlockContentChanged', loadCarousel );

// Enable HMR
if ( module.hot ) {
	module.hot.accept();
}
